import { transformConfigurableOptions, transformConfigurableOptionsRequest } from '../configurableOptions/index.js';

const transformGroupedOptions = (grouped_options)=>grouped_options?.map(({ sku , qty , metadata  })=>({
            sku,
            qty,
            configurableOptions: transformConfigurableOptions(metadata?.configurable_options)
        })) || [];
const transformGroupedOptionsRequest = (grouped_options)=>grouped_options?.map(({ sku , qty , configurableOptions  })=>({
            sku,
            qty,
            metadata: {
                configurable_options: transformConfigurableOptionsRequest(configurableOptions)
            }
        })) || null;

export { transformGroupedOptions, transformGroupedOptionsRequest };
